import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {$accountFactory} from "../../../account/$account.factory";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {AccountModel} from "../../../account/angular/models/account.model";

export class orderValidationEditorViewCtrl implements IController {

  order: any;
  onCancel: Function;
  onSave: Function;

  private loading: boolean;
  private packageTypes: any;
  private vehicleTypesRef: any;
  private orderCopy: any;
  private account: AccountModel;
  private pricePlanBundle: any;
  // private validationForm: any = {};

  /* @ngInject */
  constructor(private commonsConstants, private $account: $accountFactory,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private $log) {
  }

  $onInit() {
    this.loading = true;
    this.packageTypes = this.commonsConstants.packageTypes;
    this.vehicleTypesRef = Object.values(VehicleType);

    this.orderCopy = angular.copy(this.order);

    this.$account(this.order.entity.accountId).$asyncValue()
      .then((account) => {
        this.account = account;
        return this.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(this.order.entity.accountId);
      })
      .then((pricePlanBundle) => {
        this.pricePlanBundle = pricePlanBundle;
      })
      .catch((error) => {
        this.$log.error('Failed to init edit order', error)
      })
      .finally(() => {
        this.loading = false;
      })
  };

  onSubmit(delivery) {
    if (delivery) {
      this.orderCopy.errors = _.filter(this.orderCopy.errors, (error) => {
        return error.fieldName === 'server';
      });
      this.orderCopy.entity.serviceList[0] = delivery;
      this.onSave({order: this.orderCopy});
    }
  }

}

angular
  .module('bringoz.admin.orders')
  .component('orderValidationEditorView', {
    bindings: {
      order: '<',
      onCancel: '&',
      onSave: '&'
    },
    template: require('./order-validation-editor-view.html').default,
    controller: orderValidationEditorViewCtrl
  });

